import { render, staticRenderFns } from "./DepartmentDetails.vue?vue&type=template&id=153e2bdc"
import script from "./DepartmentDetails.vue?vue&type=script&lang=js"
export * from "./DepartmentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports